import React from "react";
import {
    FormControl,
    FormLabel,
    Input,
    FormErrorMessage
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

const sanitizeYear = (value) => {
    return value.replace(/\D/g, "").slice(0, 4);
};

const YearMaskedInput = ({
                             id,
                             label,
                             value,
                             onChange,
                             onBlur,
                             error,
                             isRequired = false,
                             isInvalid = !!error,
                             placeholder
                         }) => {
    const {t} = useTranslation();
    return (
        <FormControl isRequired={isRequired} isInvalid={isInvalid}>
            {label && (
                <FormLabel fontSize="xs" fontWeight="bold" htmlFor={id}>
                    {t(label)}
                </FormLabel>
            )}
            <Input
                variant="main"
                id={id}
                value={value}
                maxLength={4}
                placeholder={t(placeholder)}
                fontSize="sm"
                inputMode="numeric"
                pattern="\d*"
                onChange={(e) => {
                    const cleaned = sanitizeYear(e.target.value);
                    onChange({
                        target: {
                            id,
                            value: cleaned
                        }
                    });
                }}
                onBlur={() => {
                    if (onBlur) {
                        onBlur({target: {id}});
                    }
                }}
                onKeyDown={(e) => {
                    if (
                        ["e", "E", "+", "-", ".", ","].includes(e.key)
                    ) {
                        e.preventDefault();
                    }
                }}
            />
            {error && <FormErrorMessage>{t ? t(error) : error}</FormErrorMessage>}
        </FormControl>
    );
};

export default YearMaskedInput;
